import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=54300ab4"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=54300ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports